<template>
    <div>
        <!-- Modal Log Nota Fiscal -->
        <div :key="pageOne" class="modal fade" :id="id_modal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId"
            aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Logs da Nota Fiscal</h5>
                        <button type="button" class="close" @click="fechar(id_modal)" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!logs || !logs.length" :loading="loading" msg="Nenhum log registrados"
                            icon="fa-solid fa-comment-dots"></az-empty-state>

                        <div v-else class="tab-content">
                            <ul class="nav nav-tabs" role="tablist">
                                <li class="nav-item">
                                    <a class="nav-link active" data-toggle="tab" :href="'#aba1'+id_modal" role="tab">NFSe</a>
                                </li>
                                <li v-if="lista.logsPowerP" class="nav-item">
                                    <a class="nav-link" data-toggle="tab" :href="'#aba2'+id_modal" role="tab">PowerP</a>
                                </li>
                            </ul>
                            <div :id="'aba1'+id_modal" class="tab-pane fade show active" role="tabpanel">

                                <table class="table default-text-size remove-table-hover cabecalho-movel">
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Data</th>
                                            <th v-if="exibir_json">Json</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(log, irx) in logs" :key="irx">
                                            <td class="text-nowrap">
                                                <i class="fa fa-check-circle text-success fa-fw mr-2" aria-hidden="true"
                                                    v-if="checar_status(log.js_dados_retorno)"></i>
                                                <i class="fa fa-times-circle text-danger fa-fw mr-2" aria-hidden="true"
                                                    v-else></i>
                                                #{{ log.id_nota_fiscal_servico_log }}
                                            </td>
                                            <td class="text-nowrap">
                                                <span v-if="log.created_at">
                                                    {{ $util.getFormatDate(log.created_at) }}
                                                    {{ log.created_at.slice(11, 16) }}
                                                </span>
                                            </td>
                                            <td v-if="exibir_json">
                                                <template v-if="log.st_dados_retorno && log.st_dados_retorno != 'null'">
                                                    <div class="d-flex justify-content-between">
                                                        <div class="small">
                                                            <a href="#"
                                                                :class="log.view_type == 'E' ? 'font-weight-bold' : ''"
                                                                @click.prevent="mudar_renderizacao(log, 'E')">
                                                                Visualizar Envio
                                                            </a>
                                                            |
                                                            <a href="#"
                                                                :class="log.view_type == 'R' ? 'font-weight-bold' : ''"
                                                                @click.prevent="mudar_renderizacao(log, 'R')">
                                                                Visualizar Retorno
                                                            </a>
                                                            |
                                                            <a href="#"
                                                                :class="log.view_type == 'O' ? 'font-weight-bold' : ''"
                                                                @click.prevent="mudar_renderizacao(log, 'O')">
                                                                Ocultar
                                                            </a>
                                                        </div>
                                                    </div>

                                                    <div class="alert alert-warning text-wrap"
                                                        v-if="log.view_type == 'R'">
                                                        <vue-json-pretty v-if="is_json(log.js_dados_retorno)"
                                                            :data="JSON.parse(log.js_dados_retorno)" :showLength="true" />
                                                        <pre class="alert alert-warning text-wrap w-100"
                                                            v-else>{{ log.js_dados_retorno }}</pre>
                                                    </div>

                                                    <div class="alert alert-warning text-wrap"
                                                        v-if="log.view_type == 'E'">
                                                        <vue-json-pretty v-if="is_json(log.st_dados_envio)"
                                                            :data="JSON.parse(log.st_dados_envio)" :showLength="true" />
                                                        <pre class="alert alert-warning text-wrap w-100"
                                                            v-else>{{ log.st_dados_envio }}</pre>
                                                    </div>
                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                                <div class="modal-footer d-flex justify-content-between">
                                    <template v-if="lista.logs.last_page > 1">
                                        <div> 
                                            <paginate 
                                                class="mb-0"
                                                :page-count="lista.logs.last_page"
                                                :container-class="'pagination'"
                                                :page-class="'page-item'"
                                                :page-link-class="'page-link'"
                                                :prev-class="'page-link'"
                                                :next-class="'page-link'"
                                                :prev-text="'<<'"
                                                :next-text="'>>'"
                                                :click-handler="paginar">
                                            </paginate>
                                        </div>
                                    </template>
                                    <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                                </div>
                            </div>

                            <div :id="'aba2'+id_modal" class="tab-pane fade" role="tabpannel">
                                <table class="table default-text-size remove-table-hover cabecalho-movel">
                                    <thead>
                                        <tr>
                                            <th>Id</th>
                                            <th>Data</th>
                                            <th v-if="exibir_json">Json</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(log, irx) in powerP.logsPaginados" :key="irx">
                                            <td class="text-nowrap">
                                                <i class="fa fa-times-circle text-danger fa-fw mr-2" aria-hidden="true"
                                                ></i>
                                                #{{ extrair_id_powerP(log.cod_log) }}
                                            </td>
                                            <td class="text-nowrap">
                                                <span v-if="log.dt_criacao">
                                                    {{ $util.getFormatDate(log.dt_criacao) }}
                                                    {{ log.dt_criacao.slice(11, 16) }}
                                                </span>
                                            </td>
                                            <td v-if="exibir_json">
                                                <template v-if="log.log && log.log != 'null'">
                                                    <div class="d-flex justify-content-between">
                                                        <div class="small">
                                                            <a href="#"
                                                                :class="log.view_type == 'R' ? 'font-weight-bold' : ''"
                                                                @click.prevent="mudar_renderizacao(log, 'R')">
                                                                Visualizar Retorno
                                                            </a>
                                                            |
                                                            <a href="#"
                                                                :class="log.view_type == 'O' ? 'font-weight-bold' : ''"
                                                                @click.prevent="mudar_renderizacao(log, 'O')">
                                                                Ocultar
                                                            </a>
                                                        </div>
                                                    </div>

                                                    <div class="alert alert-warning text-wrap"
                                                        v-if="log.view_type == 'R'">
                                                        <vue-json-pretty v-if="is_json(log.log)"
                                                            :data="JSON.parse(log.log)" :showLength="true" />
                                                        <pre class="alert alert-warning text-wrap w-100"
                                                            v-else>{{ log.log }}</pre>
                                                    </div>

                                                </template>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table> 
                                <div class="modal-footer d-flex justify-content-between">
                                    <template v-if="powerP.logsPaginados.length > 0">
                                        <div> 
                                            <paginate 
                                                class="mb-0"
                                                :page-count="powerP.totalPaginas"
                                                :container-class="'pagination'"
                                                :page-class="'page-item'"
                                                :page-link-class="'page-link'"
                                                :prev-class="'page-link'"
                                                :next-class="'page-link'"
                                                :prev-text="'<<'"
                                                :next-text="'>>'"
                                                :click-handler="paginar_powerp">
                                            </paginate>
                                        </div>
                                    </template>
                                    <button type="button" class="btn btn-secondary" @click="fechar(id_modal)">Fechar</button>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';
import VueJsonPretty from 'vue-json-pretty';
import 'vue-json-pretty/lib/styles.css';

export default {

    data() {
        return {
            lista: {
                logs: null, 
                logsPowerP: null
            },
            loading: false,
            exibir_json: false,
            id_nfse: null,
            pageOne: false,
            powerP: {
                totalPaginas: 0,
                logsPaginados: []
            },
        }
    },

    components: {
        AzEmptyState,
        VueJsonPretty
    },

    computed: {

        id_modal: function () {
            return 'logNFSeModal_' + this.id_nfse;
        },

        logs: function () {

            if(this.lista && this.lista.logs && this.lista.logs.data) {
                return this.lista.logs.data.map(log => {
                    log.view_type = 'O';
                    return log;
                });

            } return [];
        },

        logsPowerP: function () {

            if(this.powerP && this.powerP.logsPaginados) {
                return this.powerP.logsPaginados.map(log => {
                    log.view_type = 'O';
                    return log;
                });

            } return [];

        },

    },

    methods: {

        fechar(modal) {
            $('#' + modal).modal('hide');
        },

        abrir(model_id, exibir_json = false) {

            this.$forceUpdate();
            this.exibir_json = exibir_json
            this.id_nfse = model_id
            this.pageOne = !this.pageOne;

            this.$nextTick(() => {
                this.paginar(1, 10, false);
            });


        },

        is_json(array) {

            try {
                JSON.parse(array);
            } catch (e) {
                return false;
            }
            return true;

        },

        checar_status(objectString) {
            try {

                const jsonObject = JSON.parse(objectString);
                return jsonObject.sucesso ? true : false;

            } catch (e) {
                return false;
            }
        },

        paginar(page, size = 10, comumLogs = true) {

            this.$util.load(this, {
                service: 'log_nota_fiscal',
                func: 'pegar_logs_nfse',
                parms: {
                    id_nota_fiscal_servico: this.id_nfse,
                    pagina: page,
                    tamanho: size,
                    apenas_log_padrao: comumLogs
                },
                loadTo: res => {
                  
                    if(res.logsPowerP && !res.logsPowerP.data) {
                        this.$toast.add({
                            severity: 'error',
                            summary: 'Erro',
                            detail: res.logsPowerP.message,
                            life: 5000
                        })
                    }

                    this.lista.logs = res.logs;

                    if(res.logsPowerP && res.logsPowerP.data) {
                        this.lista.logsPowerP = res.logsPowerP.data;
                    }

                    this.paginar_powerp(1);

                    this.$nextTick(() => {
                        $('#' + this.id_modal).modal("show");
                    });
                }
            });
            

        },

        paginar_powerp(page, size = 10) {
        
            if(this.lista.logsPowerP) {
                this.powerP.totalPaginas = Math.ceil(this.lista.logsPowerP.length / size);
                const offset = (page * size) - size;
                this.powerP.logsPaginados = this.lista.logsPowerP.slice(offset, size + offset);
            }

        },

        mudar_renderizacao(log, status) {
            log.view_type = status;
            this.$forceUpdate();
        },

        extrair_id_powerP(objetoId) {
            const regex = /\{([^}]+)\}/;
            const match = objetoId.match(regex);
            return match ? match[1] : null;
        }
    }
}
</script>
<style>

.cabecalho-movel thead th {
    position: initial !important;
    top: initial !important;
    background-color: initial !important;
}

.remove-table-hover tr:hover{
   background-color: #fff !important;
}

.default-text-size {
    font-size: initial !important;
}

</style>
